(ns app.front.view.group.admin.inspections.order-template
  (:require [app.domain.application.condition.model :as condition-model]
            [app.domain.inspection.model :as inspection-model]
            [app.domain.inspection.templates-config :as ins-templates-config]
            [app.front.entities :as entities]
            [app.front.file.download :as file-download]
            [app.front.ui.components :as uic]
            [app.front.ui.i18n :as ui-i18n]
            [app.front.ui.template-editor :as template-editor]
            [app.front.ui.text-editor :as text-editor]
            [app.front.util :refer [for-frag]]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.admin.templates.document-editor :as document-editor]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r])
  (:require-macros [core.util.util :as util]))

(defn order-template [template copy?]
  (-> template
      (select-keys (concat [:order.template/html-template
                            :order.template/print-css
                            :order.template/checklist-table-snippet
                            :order.template/checklist-snippet
                            :order.template/checklist-group-snippet
                            :order.template/checklist-item-snippet
                            :order.template/deficiency-html-snippet
                            :order.template/condition-table-snippet
                            :order.template/condition-snippet
                            :order.template/features
                            :order-template/phases
                            :order.template/order-html-snippet
                            :order.template/other-html-snippet
                            :order.template/party-html-snippet
                            :order.template/name]
                           (when-not copy?
                             [:domain/authority-group
                              :db/id])))
      (update :order.template/name i18n-model/strings-map)
      (update :order.template/features #(or % #{}))))


(rf/reg-event-fx ::fetch-defaults
  (fn [_]
    {:comm/command {:command    :inspection/default-order-template-content
                    :method     :get
                    :on-success [::fetch-defaults.success]}}))


(rf/reg-event-db ::fetch-defaults.success
  (fn [db [_ _ resp]]
    (assoc db ::defaults resp)))


(rf/reg-sub ::edited-template-raw
  :-> ::edited-template)


(rf/reg-sub ::defaults
  :-> ::defaults)


(rf/reg-sub ::edited-template
  :<- [::edited-template-raw]
  :<- [::defaults]
  (fn [[edited-template defaults] _]
    (merge defaults
           edited-template)))


(rf/reg-event-db ::set-edited-template
  (fn [db [_ template]]
    (-> db
        (assoc ::edited-template (order-template template false)))))


(rf/reg-event-db ::set-edited-template-value
  (fn [db [_ key value]]
    (assoc-in db [::edited-template key] value)))


(defn do-save [data]
  (when (:id data)
    [:comm/command {:command    :inspection/save-order-template
                    :method     :post
                    :notify     {:success :order/template-saved}
                    :on-success [::save-success]
                    :data       data}]))


(rf/reg-event-fx ::save-success
  (fn [_ [_ status db-changes]]
    {:dispatch-n [[::entities/apply-changes status db-changes]]}))


(rf/reg-event-fx ::save
  (fn [_ [_ id html css]]
    {:fx [[:dispatch [::set-edited-template-value :order.template/html-template html]]
          [:dispatch [::set-edited-template-value :order.template/print-css css]]
          (do-save (util/mmap id html css))]}))


(rf/reg-event-fx ::save-snippet
  (fn [_ [_ attr id value]]
    {:fx [[:dispatch [::set-edited-template-value attr value]]
          (do-save (util/mmap {attr value} id))]}))


(rf/reg-event-fx ::save-features
  (fn [_ [_ id features]]
    {:fx [[:dispatch [::set-edited-template-value :order.template/features features]]
          (do-save (util/mmap id features))]}))


(rf/reg-event-fx ::save-phases
  (fn [_ [_ id phases]]
    {:fx [[:dispatch [::set-edited-template-value :order-template/phases phases]]
          (do-save {:id                    id
                    :order-template/phases phases})]}))


(rf/reg-event-fx ::save-name
  (fn [_ [_ id name]]
    {:fx [(do-save (util/mmap id name))]}))


(rf/reg-sub ::save-new-template-disabled?
  :<- [::edited-template]
  (fn [{:order.template/keys [name]}]
    (or (empty? name)
        (->> name vals (some str/blank?) boolean))))


(rf/reg-event-fx ::create-success
  (fn [_ [_ group-id status db-changes]]
    (let [template-id (-> db-changes keys first)]
      {:dispatch-n [[::entities/apply-changes status db-changes]]
       :route/push {:route  :view/group.admin.template
                    :params {:group-id    group-id
                             :template-id template-id}}})))


(rf/reg-event-fx ::save-new-order-template
  (fn [_ [_ group-id template copy?]]
    {:comm/command {:command    :inspection/create-new-order-template
                    :method     :post
                    :notify     {:success (if copy?
                                            :order/template-copied
                                            :order/template-saved)}
                    :on-success [::create-success group-id]
                    :data       {:group-id group-id
                                 :data     template
                                 :copy?    copy?}}}))


(rf/reg-event-fx ::delete-success
  (fn [_ [_ status db-changes]]
    {:dispatch-n [[::entities/apply-changes status db-changes]]}))


(rf/reg-event-fx ::delete-order-template
  (fn [_ [_ id]]
    {:comm/command {:command    :inspection/delete-order-template
                    :data       {:entity-id id}
                    :notify     {:success :template-editor/removed}
                    :on-success [::delete-success]}}))


(rf/reg-event-fx ::copy-order-template
  (fn [_ [_ copied-template group-id]]
    {:dispatch [::save-new-order-template
                group-id
                (order-template copied-template true)
                true]}))


(defn feature-selector [{:keys [tr features template-id inherited?]}]
  (r/with-let [*modified? (r/atom false)]
    [:<>
     [:div.flex.flex-wrap
      (for-frag [feature inspection-model/order-template-features]
        [:div.w-48
         (cc/toggle {:id         (str feature)
                     :disabled   inherited?
                     :label-text (tr [feature])
                     :toggled    (contains? features feature)
                     :on-toggle  (fn [_]
                                   (reset! *modified? true)
                                   (>evt [::save-features
                                          template-id
                                          (if (features feature)
                                            (disj features feature)
                                            (conj features feature))]))})])]
     (when @*modified?
       [cc/inline-notification
        {:kind              :warning
         :class-name        "bx--inline-notification--low-contrast"
         :hide-close-button true
         :title             (tr [:inspection/order-features-note-title])
         :subtitle          (tr [:inspection/order-features-note])}])]))


(defn save-order-template-phases [id phases phase selected?]
  (let [new-phases ((if selected? conj disj) phases phase)]
    ;; At least one phase is required (see OrderTemplatePhases schema), so never let the local
    ;; state drop to empty - otherwise the UI would show an unchecked box that is never persisted.
    (when (seq new-phases)
      (>evt [::set-edited-template-value :order-template/phases new-phases])
      (when id
        (>evt [::save-phases id new-phases])))))


(defn phase-selector [{:keys [tr template-id phases inherited?]}]
  [uic/form-field-wide
   [:fieldset.bx--fieldset
    [:legend.bx--label (tr [:inspection.template.kind/phases])]
    [:div.flex.flex-wrap.gap-4.justify-start
     (for-frag [phase (sort-by name inspection-model/inspection-template-kind-phases)]
       (let [checked? (contains? phases phase)]
         (cc/checkbox {:id         (str "order-template-" template-id "-" (name phase) "-phase-checkbox")
                       ;; Prevent unchecking the last remaining phase (min one required).
                       :disabled   (or inherited?
                                       (and checked? (= 1 (count phases))))
                       :label-text (tr [phase])
                       :checked    checked?
                       :on-change  #(save-order-template-phases template-id phases phase %)})))]]])


(defn snippet-editor [{:keys [attr template template-id group-id variables inherited?]}]
  (let [tr (<sub [:tr])]
    [template-editor/editor
     (-> {:html-template (get template attr)
          :read-only?    inherited?
          :html-only?    true
          :small?        true
          :tr            tr
          :title         [:h4 (tr [attr])]
          :on-save       #(>evt [::save-snippet attr template-id %])
          :placeholders  variables
          :images        (<sub [::gas/verdict-images group-id])}
         (text-editor/with-external-edit-state attr))]))


(defn template-editor [tr group-id inherited?]
  (let [{:order.template/keys
         [html-template
          print-css
          features
          name]
         template-id :db/id
         :as         template}    (<sub [::edited-template])
        group                     (<sub [::gas/group])
        feature-flags             (<sub [::ff/enabled-flags])
        pre-issuance-inspections? (<sub [::ff/enabled? :feature-flag.id/pre-issuance-inspections])
        phases                    (set (inspection-model/order-template-phases-or-default template))]
    [acommon/section {:title (if (nil? template-id)
                               (tr [:template-editor/add-new-order-pdf-template])
                               (i18n-model/get-text-from-entities-or-map name (<sub [:language])))}
     [:div
      [ui-i18n/edit-language-selector {:allowed-locales-sub ::gas/allowed-locales}]
      [uic/form-field-wide
       [ui-i18n/localized-string-edit
        {:id                  "order-template-name"
         :disabled            inherited?
         :label-text          (tr [:inspection.pdf-template/name])
         :required            true
         :on-change           #(rf/dispatch-sync [::set-edited-template-value :order.template/name %])
         :on-end-edit         (when template-id #(>evt [::save-name template-id name]))
         :allowed-locales-sub ::gas/allowed-locales
         :strings             name}]]

      [:<>
       (when pre-issuance-inspections?
         [phase-selector (util/mmap tr template-id phases inherited?)])
       [uic/form-field-wide
        [feature-selector (util/mmap tr template-id features inherited?)]]
       [uic/form-field-wide
        [template-editor/editor
         (-> {:html-template html-template
              :read-only?    inherited?
              :print-css     print-css
              :tr            tr
              :on-save       #(>evt [::save template-id %1 %2])
              :title         [:h3 (tr [:order/template])]
              :placeholders  (cond->> (ins-templates-config/order-picker-variables feature-flags)
                               (not (inspection-model/has-checklists-v2? group feature-flags))
                               (remove #{"table-for-linked-checklists"
                                         "table-for-workspace-checklists"}))
              :images        (<sub [::gas/verdict-images group-id])}
             (p/assoc-if :preview-url (when template-id (file-download/download-href
                                                          :group/generate-order-template-preview-pdf
                                                          {:group-id    group-id
                                                           :template-id template-id})))
             (text-editor/with-external-edit-state ::main))
         [:<>
          (when (and (not inherited?) (inspection-model/has-checklists-v2? group feature-flags))
            [document-editor/editor-for-snippet
             (ins-templates-config/order-checklist-snippets "table-for-checklists")
             (util/mmap
               {:get-db-snippet  (partial get template)
                :save-db-snippet (fn [[db-reference html]]
                                   (>evt [::save-snippet db-reference template-id html]))}
               tr group-id)])
          (when (:order.template.feature/linked-deficiencies features)
            [snippet-editor (util/mmap {:attr      :order.template/deficiency-html-snippet
                                        :variables (ins-templates-config/order-deficiency-snippet-variables
                                                     feature-flags)}
                                       template-id group-id template inherited?)])
          (when (condition-model/template-snippets-enabled? group feature-flags)
            [document-editor/editor-for-snippet
             {:db-reference       :order.template/condition-table-snippet
              :template-reference "table-for-conditions"
              :template-variables condition-model/condition-snippet-table-variables
              :pdf-title          :order.template/condition-table-snippet
              :snippets           [{:db-reference       :order.template/condition-snippet
                                    :template-reference "condition-items"
                                    :template-variables condition-model/condition-snippet-variables
                                    :pdf-title          :order.template/condition-snippet}]}
             (util/mmap
               {:read-only?      inherited?
                :get-db-snippet  (partial get template)
                :save-db-snippet (fn [[db-reference html]]
                                   (>evt [::save-snippet db-reference template-id html]))}
               tr group-id)])
          (when (:order.template.feature/linked-orders features)
            [snippet-editor (util/mmap {:attr      :order.template/order-html-snippet
                                        :variables ins-templates-config/order-order-snippet-variables}
                                       template-id group-id template inherited?)])
          (when (:order.template.feature/other-items features)
            [snippet-editor (util/mmap {:attr      :order.template/other-html-snippet
                                        :variables ins-templates-config/order-other-snippet-variables}
                                       template-id group-id template inherited?)])
          [snippet-editor (util/mmap {:attr      :order.template/party-html-snippet
                                      :variables ins-templates-config/order-party-snippet-variables}
                                     template-id group-id template inherited?)]]]]]
      (when (and (not inherited?) (nil? template-id))
        [uic/form-field-wide
         (cc/button
           {:icon             i/save
            :icon-description (tr [:save])
            :on-click         #(>evt [::save-new-order-template group-id template false])
            :disabled         (<sub [::save-new-template-disabled?])}
           (tr [:save]))])]]))


(defn view [tr group-id {template-id :db/id :as template} inherited?]
  (let [current-template (<sub [::edited-template-raw])
        current-id       (:db/id current-template)]
    (when (or (not= template-id current-id)
              (nil? current-template))
      (>evt [::set-edited-template template]))
    [template-editor tr group-id inherited?]))
